<template>
  <AutoDialogDrawer
    v-if="performanceStore.modalOpen"
    class="performance-modal"
    placement="centre"
    modal
    dismissible
    @close="performanceStore.modalOpen = false"
  >
    <template #title>Performance</template>
    <div>
      <DataTable
        :cols-map="{
          '#': 'responseNr',
          Method: 'method',
          URL: 'url',
          Status: 'status',
          'Total Elapsed (ms)': 'totalElapsedMs',
          'SQL Queries': 'sqlCount',
        }"
        :rows="performanceStore.entries"
      >
      </DataTable>
    </div>
  </AutoDialogDrawer>
</template>
<script setup lang="ts">
const performanceStore = usePerformanceStore();
</script>
<style lang="css" scoped>
.performance-modal {
  width: auto !important;
  height: auto !important;
  max-width: none;
  max-height: none;
  margin: 5% 10%;
}
</style>
